import { useEffect, useState } from "react";
import useApi from "../utils/UseAPI";
import Spinner from 'react-bootstrap/Spinner';
import SanitizeHref from "../utils/SanitizeHref";

function RelatedLink({ pageID }) {
    const [relatedLinks, setRelatedLinks] = useState([]);
    const { error, processing, getRequest } = useApi();

    useEffect(() => {
    const fetchLinks = async () => {
        const [data, status] = await getRequest(null, `page/${pageID}/related-links`);
        if (status === 200 && data?.data) {
            setRelatedLinks(data.data.sort((a, b) => a.sort - b.sort));
        } else {
            console.error("API Error:", error);
        }
    };
    fetchLinks();
   
}, [pageID]); 

    return (
        <nav aria-labelledby="related-links-title">
            <h2 id="related-links-title" style={{ fontSize: "22px", marginTop: "0px", fontWeight: "bold" }}>
                Related Links
            </h2>
            
            {processing ? (
                <Spinner animation="border" variant="success" role="status">
                    <span className="visually-hidden">Loading related links...</span>
                </Spinner>
            ) : (
                <ul className="no-bullet" style={{ listStyle: 'none', paddingLeft: 0 }}>
                    {relatedLinks.map((data, index) => (
                        <li key={data.id || index}>
                            <a 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="quick-links-body" 
                                href={SanitizeHref(data.url)}
                            >
                                {data.name} 
                                <span className="visually-hidden"> (opens in a new tab)</span>
                            </a>

                            {/* Accessible Nested List for Children */}
                            {data.children && data.children.length > 0 && (
                                <ul style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                    {data.children.map((child, childIndex) => (
                                        <li key={child.id || childIndex}>
                                            <a 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="quick-links-body indented-list" 
                                                href={SanitizeHref(child.url)}
                                            >
                                                <span aria-hidden="true">- </span>
                                                {child.name}
                                                <span className="visually-hidden"> (opens in a new tab)</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </nav>
    );
}

export default RelatedLink;
